import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TradeStatusRequestImpl } from "../model/impl/TradeStatusRequestImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TradeStatusRequestImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TradeStatusRequestImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.accountCodes != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(1),
        false,
        encodable.accountCodes,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.branchCds != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(2),
        false,
        encodable.branchCds,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.ccyPairs != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(3),
        false,
        encodable.ccyPairs,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCodes != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(4),
        false,
        encodable.clientCodes,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.dealIds != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(5),
        false,
        encodable.dealIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.fillComparitor != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(6),
        true,
        encodable.fillComparitor,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.fillUserIds != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(7),
        false,
        encodable.fillUserIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.maxResults != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(8),
        false,
        encodable.maxResults,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.orderIds != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(9),
        false,
        encodable.orderIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.orderTypes != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(10),
        false,
        encodable.orderTypes,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.placingUserCodes != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(11),
        false,
        encodable.placingUserCodes,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.products != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(12),
        false,
        encodable.products,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupIds != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(13),
        false,
        encodable.salesGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupIds != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        true,
        TradeStatusRequestImplEncoder.fidTypeMap.get(14),
        false,
        encodable.traderGroupIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.isConfirmedBySales != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(15),
        false,
        encodable.isConfirmedBySales,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.includeComponentDetails != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(16),
        false,
        encodable.includeComponentDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.includeDealConfirmations != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(17),
        false,
        encodable.includeDealConfirmations,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.includeCounterPartyInformation != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(18),
        false,
        encodable.includeCounterPartyInformation,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.brokerId != null) {
      this.baseEncoder.writeStartFid(200, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(200),
        false,
        encodable.brokerId,
        streamout,
      );
      this.baseEncoder.writeEndFid(200, streamout);
    }
    /*Object encoding*/
    if (encodable.secureToken != null) {
      this.baseEncoder.writeStartFid(300, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(300),
        true,
        encodable.secureToken,
        streamout,
      );
      this.baseEncoder.writeEndFid(300, streamout);
    }
    /*Object encoding*/
    if (encodable.proxySessionId != null) {
      this.baseEncoder.writeStartFid(999, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(999),
        false,
        encodable.proxySessionId,
        streamout,
      );
      this.baseEncoder.writeEndFid(999, streamout);
    }
    /*Object encoding*/
    if (encodable.svrRxTime != null) {
      this.baseEncoder.writeStartFid(10000, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(10000),
        false,
        encodable.svrRxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10000, streamout);
    }
    /*Object encoding*/
    if (encodable.svrTxTime != null) {
      this.baseEncoder.writeStartFid(10001, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(10001),
        false,
        encodable.svrTxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10001, streamout);
    }
    /*Object encoding*/
    if (encodable.cliTxTime != null) {
      this.baseEncoder.writeStartFid(10002, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(10002),
        false,
        encodable.cliTxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10002, streamout);
    }
    /*Object encoding*/
    if (encodable.cliRxTime != null) {
      this.baseEncoder.writeStartFid(10003, streamout);
      this.baseEncoder.writeObject(
        false,
        TradeStatusRequestImplEncoder.fidTypeMap.get(10003),
        false,
        encodable.cliRxTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(10003, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,TradeStatusRequestImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.Long"],
    [6, "com.bcdfx.model.DateComparitor"],
    [7, "java.lang.Long"],
    [8, "java.lang.Integer"],
    [9, "java.lang.Long"],
    [10, "com.bcdfx.model.OrderType"],
    [11, "java.lang.String"],
    [12, "com.bcdfx.model.Product"],
    [13, "java.lang.Long"],
    [14, "java.lang.Long"],
    [15, "java.lang.Boolean"],
    [16, "java.lang.Boolean"],
    [17, "java.lang.Boolean"],
    [18, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [200, "java.lang.String"],
    [300, "com.bcdfx.security.SecureToken"],
    [999, "java.lang.String"],
    [10000, "java.lang.Long"],
    [10001, "java.lang.Long"],
    [10002, "java.lang.Long"],
    [10003, "java.lang.Long"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TradeStatusRequestImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.accountCodes = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.branchCds = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.ccyPairs = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.clientCodes = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.dealIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.DateComparitor = this.baseEncoder.readObject(
            true,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.fillComparitor = <CubiqTS.DateComparitor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.fillUserIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.maxResults = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.orderIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: Array<CubiqTS.OrderType> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.orderTypes = <Array<CubiqTS.OrderType>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.placingUserCodes = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: Array<CubiqTS.Product> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.products = <Array<CubiqTS.Product>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.salesGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            TradeStatusRequestImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.traderGroupIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.isConfirmedBySales = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.includeComponentDetails = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.includeDealConfirmations = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.includeCounterPartyInformation = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 200: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(200),
            streamin,
          );
          encodable.brokerId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 300: {
          /*Object encoding*/
          let val: CubiqTS.SecureToken = this.baseEncoder.readObject(
            true,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(300),
            streamin,
          );
          encodable.secureToken = <CubiqTS.SecureToken>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 999: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(999),
            streamin,
          );
          encodable.proxySessionId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10000: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(10000),
            streamin,
          );
          encodable.svrRxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10001: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(10001),
            streamin,
          );
          encodable.svrTxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10002: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(10002),
            streamin,
          );
          encodable.cliTxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10003: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradeStatusRequestImplEncoder.fidTypeMap.get(10003),
            streamin,
          );
          encodable.cliRxTime = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,TradeStatusRequestImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TradeStatusRequestImplEncoder.fidTypeMap.has(fid);
  }
}
